import { Box, Text } from 'pcln-design-system'
import React from 'react'

function PackageBadge({ badgeText, ...props }) {
  return (
    <Box borderRadius='full' color='primary' py='12px' px={3} rounded='right' width='fit-content' {...props}>
      <Text textStyle='heading6'>{badgeText}</Text>
    </Box>
  )
}

export default PackageBadge
